import { http } from './http'
import {
  NotificationPayload,
  Notifications,
  INotification,
} from '../../common/models'

export const getAllNotifications = (festivalEditionId: string) =>
  http.get<Notifications[]>(
    `/operations/notification?festivalEditionId=${festivalEditionId}`,
  )

export const createNotification = (data: NotificationPayload) =>
  http.post('/operations/notification', data)

export const getNotification = (id: string) =>
  http.get<INotification>(`/operations/notification/${id}`)

export const deleteNotification = (id: string) =>
  http.delete(`/operations/notification/${id}`)
